import styled from 'styled-components';

const CategoryItemWrapper = styled.div`
  text-align: center;
  // height: 145px;
  // width: 170px;

  img {
    // height: 115px;
    width: 115px;
    // margin: 15px auto 0;
    // max-height: 95px;
    min-height: 20px;
    // position: relative;
  }

  .disable {
    filter: blur(1px);
    // background-color: rgba(248, 247, 216, 0.7);
    // position: absolute;
    // z-index: 999;
  }

  .category-name {
    font-family: 'Almarai', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
  }
  .category-name-underline {
    font-family: 'Almarai', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    text-decoration: underline;
  }
`;

export default CategoryItemWrapper;
